


// import React, { useState } from "react";
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
//     Divider,
// } from "@mui/material";

// import './PostModal.css'; // Import external CSS
// // import "../../../../Components/ModalCss/BannerinputGetModal.css";

// import { MdCancel } from "react-icons/md";
// import { useSelector } from "react-redux";

// const PostJobViewModal = ({
//     open,
//     onClose,
//     setSubmittedValues,
//     submittedValues,
// }) => {
//     const [uploadedFile, setUploadedFile] = useState(null);


//     const { getJobById } = useSelector(
//         (state) => state?.getJobById
//     );

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "600px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: "relative" }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: "absolute",
//                             top: 8,
//                             right: 8,
//                             color: 'white',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Box>
//                             <Typography className="custom-title-text">Edit Profile</Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>
//                 <DialogContent>
//                     {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
//                         <CancelSharp
//                             style={{ display: { sx: "none", md: "block" } }}
//                             // onClick={() => {
//                             //     navigate("/")
//                             // }}
//                         />
//                     </Box> */}
//                     hi2

//                 </DialogContent>

//             </Box>
//         </Dialog>
//     );
// };

// export default PostJobViewModal;

import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
    Box,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import '../PostJob/PostModal.css';

const PostInternshipViewModal = ({ open, onClose }) => {

    const { getInternshipById } = useSelector((state) => state?.getInternshipById);

    const internshipFields = [
        { label: "Company Name", key: "company_name" },
        { label: "Company Address", key: "company_address" },
        { label: "Company City", key: "company_city" },
        { label: "Offered To", key: "offered_to" },
        { label: "Place of Interview", key: "place_of_interview" },
        { label: "Internship Location", key: "internship_location" },
        { label: "Total Vacancies", key: "total_vacancies" },
        { label: "Stipend (Per Month)", key: "stipend_per_month", suffix: "K" },
        { label: "Starting Date", key: "starting_date", isDate: true },
        { label: "Closing Date", key: "closing_date", isDate: true },
        { label: "Contact Person", key: "contact_person" },
        { label: "Mobile No", key: "mobile_no" },
        { label: "Internship URL", key: "url", isLink: true },
        { label: "Description", key: "description" },
    ];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: 'white',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography className="subtitle1"  sx={{color:"white"}}>Internship details</Typography>
                    </DialogTitle>
                </Box>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {internshipFields.map((item, index) => {
                            const value = getInternshipById?.data?.[item.key];

                            if (!value) return null;

                            return (
                                <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {item.label}:
                                    </Typography>
                                    <Typography variant="body1">
                                        {item.isArray
                                            ? value.join(", ")
                                            : item.isLink
                                                ? (
                                                    <a href={value} target="_blank" rel="noopener noreferrer">
                                                        {value}
                                                    </a>
                                                )
                                                : item.isDate
                                                    ? formatDate(value)
                                                    : `${value}${item.suffix || ''}`}
                                    </Typography>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default PostInternshipViewModal;
